import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from './../../models/id-name.model';
import { PeReportSubject } from './../../enums/pe-report-subject.enum';

@Pipe({
  name: 'peReportSubject',
  standalone: false
})
export class PeReportSubjectPipe implements PipeTransform {
  public transform(value: PeReportSubject): string {
    return getPeReportSubject(value);
  }
}

export function getPeReportSubject(value: PeReportSubject): string {
  switch (value) {
    case PeReportSubject.Employee:
      return 'Employee';
    case PeReportSubject.Supervisor:
      return 'Supervisor';
    default:
      throw new Error(`Unsupported value for PeReportSubject: ${value}.`);
  }
}

export function getPeReportSubjectList(): IdName[] {
  return enumToList(PeReportSubject, getPeReportSubject);
}
